// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__5gBTv","input":"SearchBar_input__11s+l","icon":"SearchBar_icon__WXG7J"};